import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import MindsetsJsSDK from "mindsets-js-sdk";

import STable from './STable';

export default function ({dataStudentTable, selectPage}) {
    return (
        <div>
            <STable
                dataStudentTable={dataStudentTable}
                selectPage={selectPage}
            />
        </div>
    );
}
